import React, { createContext, useContext, useState, ReactNode } from "react";
import Shepherd, { StepOptions, TourOptions } from "shepherd.js";
import "shepherd.js/dist/css/shepherd.css";

interface TourContextProps {
    startTour: (steps: StepOptions[], options?: Partial<TourOptions>) => void;
}

const TourContext = createContext<TourContextProps | undefined>(undefined);

export const useTour = () => {
    const context = useContext(TourContext);
    if (!context) {
        throw new Error("useTour deve ser usado dentro de um TourProvider");
    }
    return context;
};

interface TourProviderProps {
    children: ReactNode;
}

export const TourProvider: React.FC<TourProviderProps> = ({ children }) => {
    const [tour, setTour] = useState<Shepherd.Tour | null>(null);

    const startTour = (steps: StepOptions[], options?: Partial<TourOptions>) => {
        // Cancela tour anterior
        if (tour) {
            tour.cancel();
        }

        const newTour = new Shepherd.Tour({
            defaultStepOptions: {
                scrollTo: true,
                cancelIcon: { enabled: true },
                ...options?.defaultStepOptions,
            },
            useModalOverlay: true,
            ...options,
        });

        steps.forEach((step) => newTour.addStep(step));

        setTour(newTour);
        newTour.start();
    };

    return (
        <TourContext.Provider value={{ startTour }}>
            {children}
        </TourContext.Provider>
    );
};
